let configCache = null;

export const getConfig = async () => {
  if (configCache) return configCache;

  const configPath = `${process.env.PUBLIC_URL}/config.json`;
  console.log("🔍 Loading config from:", configPath);

  const response = await fetch(configPath, { cache: "no-store" });
  if (!response.ok) {
    throw new Error(`❌ Cannot load config from ${configPath} (status: ${response.status})`);
  }

  configCache = await response.json();
  return configCache;
};

export const getApiBaseUrl = async () => {
  const config = await getConfig();
  return config.apiBaseUrl;
};
